<div #shapeSelector class="shape-selector"></div>
